import type { CSSProperties } from "react";

export const DRAWER_COMBOBOX_PROPS = {
  withinPortal: true,
  zIndex: 1001,
  position: "bottom-start" as const,
  middlewares: { flip: true, shift: true },
};

/**
 * Visual highlight for a Paper/card that was just added or edited — a teal ring
 * plus a soft glow. Spread onto the element's `style`. Reusable across every
 * list so the "just changed" affordance is consistent.
 */
export const HIGHLIGHT_STYLE: CSSProperties = {
  borderColor: "var(--mantine-color-teal-5)",
  boxShadow:
    "0 0 0 1px var(--mantine-color-teal-2), 0 4px 16px var(--mantine-color-teal-1)",
};

/** Background tint for a just-added/edited TABLE row (a ring/shadow can't sit on a <tr>). */
export const HIGHLIGHT_ROW_BG = "var(--mantine-color-teal-0)";

/** Convenience: the highlight style when `highlighted`, otherwise an empty object. */
export const highlightStyle = (highlighted: boolean): CSSProperties =>
  highlighted ? HIGHLIGHT_STYLE : {};